export const HOME_SECTIONS = [
  { id: 'about', label: 'About' },
  { id: 'services', label: 'Approach' },
  { id: 'projects', label: 'Portfolio' },
  { id: 'reviews', label: 'Why Tricore' },
];
